import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { ProcedureOneService } from '../../services/procedures/procedure-one.service';
import { StationService } from '../../services/stations.service';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { environment } from '../../../environments/environment';
import {FilesService} from '../../services/files.service';
import {ProceduresService} from '../../services/procedures.service';

@Component({
  selector: 'ngx-procedure-one',
  templateUrl: './procedure-one.component.html',
  styleUrls: ['./procedure-one.component.scss'],
})
export class ProcedureOneComponent implements OnInit {
  @ViewChild(SignaturePad, { static: false }) signaturePad: SignaturePad;
  signaturePadOptions: Object;
  @Input() stationId;
  state = 'Actividades';
  signingPolitics = false;
  editSignPolicy = false;
  signPolitics = {
    sign: null,
  };
  editPolitics = false;
  stationDetail = {business_name: ''};
  documents = {
    politics: '',
    programaSeguimiento: '',
  };
  loading = false;
  downloading = false;
  mockData = {
    id: 0,
    editMission: false,
    editVision: false,
    custom_mock: null,
    data: { policy: '', mission: '', vision: '' },
  };
  editContentPolicy = false;

  constructor(
    private procedureService: ProcedureOneService,
    private stationService: StationService,
    private fileService: FilesService,
    private proceduresService: ProceduresService,
  ) {
    const width = document.documentElement.clientWidth * .36;
    this.signaturePadOptions = {
      'minWidth': 0.8,
      maxWidth: 1,
      'backgroundColor': 'RGBA(245, 247, 249, 1.00)',
      'canvasWidth': width,
    };
  }

  async ngOnInit() {
    await this.getPolicy();
    await this.getStationData();
    await this.generateDocument();
    await this.getMockDocument();
  }

  async getMockDocument() {
    this.loading = true;
    const [error, response] = await this.proceduresService.getMocksForNameAndSection(this.stationId, 'procedures', 'politics');
    this.loading = false;
    if (error) return this.alert('Error', 'error', 'Oops... ocurrio algo al intentar cargan el contenido');
    this.mockData = response.data[0];
    console.error(this.mockData)
    // validate mock data replace data mock parent
    if (this.mockData.custom_mock) {
      this.mockData.data.policy = this.mockData.custom_mock.data.policy;
      if (this.mockData.custom_mock.data.mission) {
        this.mockData.editMission = true
        this.mockData.data.mission = this.mockData.custom_mock.data.mission
      }
      if (this.mockData.custom_mock.data.vision) {
        this.mockData.editVision = true
        this.mockData.data.vision = this.mockData.custom_mock.data.vision
      }
    } else {
      this.mockData.data.policy = this.mockData.data.policy.replace('{{company_name}}', this.stationDetail.business_name);
    }
  }

  async saveMockPolicy () {
    this.loading = true;
    if (!this.mockData.editMission) delete this.mockData.data.mission
    if (!this.mockData.editVision) delete this.mockData.data.vision
    // validate edit's true
    const [error] = await this.proceduresService.editOrStoreItemMock({
      station_id: this.stationId,
      mock_id: this.mockData.id,
      data: this.mockData.data,
    });
    this.loading = false;
    if (error) return this.alert('Error', 'error', 'Oops... ocurrio algo, intentalo mas tarde');
    await this.getMockDocument()
    this.editContentPolicy = false;
    this.alert('Éxito', 'success', 'Se modifico el documento');
  }

  formatedPolicy() {
    // @ts-ignore
    return this.mockData.data.policy.replaceAll('-', '<br> -');
  }

  onChangeTab(event) {
    this.state = event.tabTitle;
  }

  clearSignature() {
    this.signaturePad.clear();
  }

  async getPolicy() {
    const [error, { data: result }]: any = await this.procedureService.getPolicy(this.stationId);
    if (error) return this.alert('Oops, algo ocurrio, intenta más tarde', 'error');
    if (result )this.signPolitics = result;
  }

  async signPolitic() {
    this.signingPolitics = true;

    const sign = {
      sign: this.signaturePad.toDataURL(),
    };

    const [error] = await this.procedureService.signPolicy(this.stationId, sign);
    if (error) { this.signingPolitics = false; return this.alert('Oops, intenta más tarde', 'error'); }
    this.getPolicy();
    this.signingPolitics = false;
    this.alert('Política firmada con éxito');
    this.clearSignature();
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  async updatePolitic() {
    this.signingPolitics = true;

    const sign = {
      sign: this.signaturePad.toDataURL(),
    };

    const [error] = await this.procedureService.updateSignPolicy(this.stationId, sign);
    if (error) { this.signingPolitics = false; return this.alert('Oops, intenta más tarde', 'error'); }
    this.getPolicy();
    this.editPolitics = false;
    this.signingPolitics = false;
    this.alert('Política editada con éxito');
    this.clearSignature();
  }

  async downloadPolitics() {
    const [error, res] = await <any>this.procedureService.downloadPolitics(this.stationId);
    if (error) return error;
    if (res.data && res.data.file) {
      window.open(res.data.file, '_blank');
    }
  }

  async generateDocument() {
    this.documents.politics = `${environment.baseEndpoint}/filesGeneratorv2/implementation/one/policies/${this.stationId}`;
    this.documents.programaSeguimiento = `${environment.baseEndpoint}/filesGeneratorv2/implementation/two/environmental/impacts/three/${this.stationId}`;
  }

  async getStationData () {
    const [err, station]: any = await this.stationService.getStationDataById(this.stationId);
    if (err) console.error(err);
    this.stationDetail = station.data;
  }

  async downloadFile(url) {
    this.downloading = true;
    await this.fileService.downloadFile(url);
    this.downloading = false;
  }

}
